"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Text_1 = require("./Text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return Text_1.Text; } });
//# sourceMappingURL=index.js.map